import React, { Component } from 'react';

const UserContext = React.createContext();

export const UserConsumer = UserContext.Consumer;

class UserProvider extends Component {

    render () {
        return (
            <UserContext.Provider value={
                this.props.value ? this.props.value :
                    {
                    }
                }>
                {this.props.children}
            </UserContext.Provider>
        );
    }
}

export default UserProvider;
